import React from 'react';
import Popup from '../components/Popup';
import { mentionsLegales, CGUs } from '../../config/legal';

class Legal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showMentionsLegales: false,
      showCGUs: false,
    };
    this.handleMentionsLegalesClick = this.handleMentionsLegalesClick.bind(
      this
    );
    this.handleCGUsClick = this.handleCGUsClick.bind(this);
  }

  handleMentionsLegalesClick() {
    this.setState((state) => ({
      showMentionsLegales: !state.showMentionsLegales,
      showCGUs: false,
    }));
  }
  handleCGUsClick() {
    this.setState((state) => ({
      showCGUs: !state.showCGUs,
      showMentionsLegales: false,
    }));
  }

  render() {
    const { showMentionsLegales, showCGUs } = this.state;
    const { layout } = this.props;
    return (
      <div>
        <Popup
          show={showMentionsLegales}
          title={mentionsLegales.popup.title}
          corps={mentionsLegales.popup.corps}
          handlePopupClose={this.handleMentionsLegalesClick}
        />
        <Popup
          show={showCGUs}
          title={CGUs.popup.title}
          corps={CGUs.popup.corps}
          handlePopupClose={this.handleCGUsClick}
        />
        <div className={`legal ${layout}`}>
          <a
            style={{ textDecoration: 'underline', color: 'inherit' }}
            href="https://lancezvous.bnpparibas/protection-des-donnees"
            target="_blank"
            rel="noopener noreferrer">
            {mentionsLegales.link}
          </a>
          <a
            style={{ textDecoration: 'underline', color: 'inherit' }}
            href="https://lancezvous.bnpparibas/CGU"
            target="_blank"
            rel="noopener noreferrer">
            {CGUs.link}
          </a>
        </div>
      </div>
    );
  }
}

export default Legal;



// WEBPACK FOOTER //
// ./src/views/layouts/Legal.js